// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"400":"map-content-resort","778":"tiles","907":"map-content"}[chunkId] + "." + __webpack_require__.h() + ".css";
};